var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.09 48.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcfffa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 24.31 7.72 20.92 15.44 17.54 15.44 24.31 15.44 31.08 7.72 27.7 0 24.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.73 16.18 52.57 9.7 39.55 9.7 39.55 1.35 37.97 0 29.67 0 27.47 1.75 27.47 3.94 29.74 3.94 29.67 10.4 23.07 12.42 18.58 16.59 18.58 24.31 18.58 32.02 23.07 36.2 29.67 38.21 29.74 44.67 27.47 44.67 27.47 46.86 29.67 48.62 37.97 48.62 39.55 47.26 39.55 38.92 52.57 38.92 86.73 32.44 91.09 27.95 91.09 24.31 91.09 20.67 86.73 16.18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressShip);
export default __webpack_public_path__ + "static/media/progress-ship.5c27431aa61b5cc1b19099e0f501c10b.svg";
export { ForwardRef as ReactComponent };